import { Box, Typography, Divider, Button, Paper } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PrintIcon from "@mui/icons-material/Print";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
// import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export const PaymentReceipt = ({ info }) => {
    if (!info) return null;

    const statusText = {
        1: "Aprobada",
        2: "Fallida",
        3: "Pendiente",
        4: "Rechazada",
    }[info.x_cod_response] || "Desconocido";

    const statusColor = {
        1: "green",
        2: "red",
        3: "orange",
        4: "red",
    }[info.x_cod_response] || "gray";

    const handlePrint = () => {
        window.print();
    };

    const paymentTypeLabel = (raw) => {
        if (!raw && raw !== 0) return "";
        const s = String(raw).trim();
        const key = s.toUpperCase();

        const map = {
            // common tokens / aliases
            TDC: "Tarjeta de Crédito",
            CREDIT: "Tarjeta de Crédito",
            CREDIT_CARD: "Tarjeta de Crédito",
            DEBIT: "Tarjeta Débito",
            DEBIT_CARD: "Tarjeta Débito",
            CARD: "Tarjeta",
            CARD_TOKEN: "Tarjeta (token)",
            PSE: "PSE (Transferencia Bancaria)",
            EFECTY: "Efectivo (Efecty)",
            BALOTO: "Baloto (Punto de pago)",
            NEQUI: "Nequi",
            DAVIPLATA: "Daviplata",
            PAYPAL: "PayPal",
            COD: "Contra entrega",
            CASH: "Efectivo",
            // add other known codes here...
        };

        return map[key] || s;
    };

    const franchiseLabel = (fr) => {
        if (!fr) return "";
        const f = String(fr).trim().toUpperCase();
        const map = {
            VS: "VISA",
            MC: "MASTERCARD",
            AM: "AMEX",
            DN: "DINERS",
            CR: "CARNET",
            AX: "AMEX",
            PSE: "PSE",
        };
        return map[f] || fr;
    };

    return (
        <Paper
            elevation={4}
            sx={{
                mt: 1,
                p: 2,
                borderRadius: 3,
                backgroundColor: "white",
            }}
        >
            {(() => {
                const code = Number(info.x_cod_response);
                if (code === 1) {
                    return (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1.5,
                                pt: 0,
                                pl: 1.5,
                                pr: 1.5,
                                pb: 1.5,
                                borderRadius: 1,
                                bgcolor: "grey.50",
                            }}
                            mb={0}
                        >
                            <MailOutlineIcon sx={{ color: "primary.main", fontSize: 28, mt: "2px" }} />
                            <Box>
                                <Typography variant="body2" color="text.primary" sx={{ fontWeight: 600 }}>
                                    Te enviaremos un correo con instrucciones
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Revisa tu bandeja de entrada (incluye la carpeta de correo no deseado) para completar el proceso.
                                </Typography>
                            </Box>
                        </Box>
                    );
                }

                if (code === 3) {
                    return (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1.5,
                                pt: 0,
                                pl: 1.5,
                                pr: 1.5,
                                pb: 1.5,
                                borderRadius: 1,
                                bgcolor: "grey.50",
                            }}
                            mb={0}
                        >
                            <HourglassEmptyIcon sx={{ color: "warning.main", fontSize: 28, mt: "2px" }} />
                            <Box>
                                <Typography variant="body2" color="text.primary" sx={{ fontWeight: 600 }}>
                                    Pago pendiente
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    El pago está en estado pendiente. Te notificaremos por correo cuando haya actualización.
                                </Typography>
                            </Box>
                        </Box>
                    );
                }

                // codes 2 and 4: do not provide follow-up instructions
                return (
                    <></>
                );
            })()}

            <Divider />

            <Box mt={1} mb={1} textAlign="center">
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: "1rem",
                        color: statusColor,
                    }}
                >
                    Estado: {statusText}
                </Typography>
            </Box>

            <Divider />

            <Box mt={2}>
                <Typography><strong>Referencia:</strong> {info.x_ref_payco}</Typography>
                <Typography><strong>Respuesta:</strong> {info.x_response}</Typography>
                <Typography><strong>Descripción:</strong> {info.x_description}</Typography>
                <Typography><strong>Factura:</strong> {info.x_id_invoice}</Typography>
                <Typography><strong>Monto:</strong> {info.x_amount} {info.x_currency_code}</Typography>
                <Typography><strong>Método de pago:</strong> {paymentTypeLabel(info.x_type_payment)}</Typography>
                <Typography><strong>Franquicia:</strong> {franchiseLabel(info.x_franchise)}</Typography>
                <Typography><strong>Autorización:</strong> {info.x_approval_code}</Typography>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle1" fontWeight={700}>Datos del cliente</Typography>
            <Typography><strong>Nombre:</strong> {info.x_customer_name}</Typography>
            <Typography><strong>Correo:</strong> {info.x_customer_email}</Typography>
            <Typography><strong>Teléfono:</strong> {info.x_customer_movil}</Typography>

            <Divider sx={{ my: 2 }} />

            <Typography><strong>Fecha y hora:</strong> {info.x_transaction_date}</Typography>

            <Box textAlign="center" mt={3}>
                <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    loadingPosition="start"
                    startIcon={<PrintIcon />}
                    size="large"
                    onClick={handlePrint}
                >
                    Imprimir recibo
                </Button>
            </Box>
        </Paper>
    );
};
